/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import { shuffleArray } from '../../helpers/utils';
import examType6Constants from '../constants/examType6Constants';
import examType6Services from '../services/examType6Services';

// Retry sendTest jusqu'à MAX_RETRIES fois avec délai exponentiel
const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 2000;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const sendTestWithRetry = async (testId, body, attempt = 0) => {
  try {
    const res = await examType6Services.sendTest(testId, body);
    return { success: true, data: res };
  } catch (err) {
    if (attempt < MAX_RETRIES - 1) {
      await delay(RETRY_DELAY_MS * (attempt + 1));
      return sendTestWithRetry(testId, body, attempt + 1);
    }
    return { success: false, error: err };
  }
};

function initTest(id, body) {
  function request() {
    return {
      type: examType6Constants.INIT_REQUEST,
    };
  }

  function success(exam) {
    return {
      type: examType6Constants.INIT_SUCCESS,
      exam,
    };
  }

  function failure(error) {
    return {
      type: examType6Constants.INIT_FAILURE,
      error,
    };
  }

  return (dispatch, getState) => {
    dispatch(request());
    const state = getState();
    examType6Services.getTest(state.user.userData._id, id)
      .then((res) => {
        if (!res || res === null) {
          examType6Services.initTest(id, body)
            .then(
              (exam) => {
                // shuffleArray(exam.questions);
                localStorage.setItem('exam', JSON.stringify(exam));
                localStorage.setItem('timeLeft', JSON.stringify(body.timer));
                dispatch(success(exam));
              },
              (error) => {
                dispatch(failure(error ? error.toString() : 'error'));
              },
            )
            .catch((e) => dispatch(failure(e ? e.toString() : 'error')));
        } else {
          examType6Services.getQuestionPool(res.pool)
            .then((questionPool) => {
              const questionsArr = questionPool.questions.map((question) => {
                const answersArr = question.answers.map((answer) => ({
                  text: answer.text,
                }));
                return ({
                  _id: question._id,
                  name: question.name || '',
                  type: question.type || '',
                  media: question.media || '',
                  level: question.level || '',
                  category: question.category || '',
                  subcategory: question.subcategory || '',
                  answers: answersArr,
                });
              });

              // formatting answers arr
              const tempanswers = res.answers.map((answer) => ({
                answerIndex: answer.answerIndex,
                question: answer.question._id,
                created_at: new Date(answer.created_at),
              }));

              const shuffledQuestionsArr = [];
              const alreadyAnsweredQuestions = [];

              questionsArr.forEach((question) => {
                let found = false;
                tempanswers.forEach((answer) => {
                  if (answer.question === question._id) {
                    found = true;
                    alreadyAnsweredQuestions.push(question);
                  }
                });
                if (!found) {
                  shuffledQuestionsArr.push(question);
                }
              });

              // shuffleArray(shuffledQuestionsArr);
              // creating examObj with questions arr
              const examObj = {
                timer: res.timer,
                finish: false,
                testId: res._id,
                questions: [...alreadyAnsweredQuestions, ...shuffledQuestionsArr],
                descriptionKN: questionPool.descriptionKN ? questionPool.descriptionKN : '',
                descriptionRC: questionPool.descriptionRC ? questionPool.descriptionRC : '',
                descriptionOC: questionPool.descriptionOC ? questionPool.descriptionOC : '',
              };

              localStorage.setItem('exam', JSON.stringify(examObj));
              localStorage.setItem('answers', JSON.stringify(tempanswers));
              localStorage.setItem('currentQuestion', JSON.stringify(tempanswers.length));
              localStorage.setItem('timeLeft', JSON.stringify(res.timer));
              dispatch(success(examObj));
            })
            .catch((error) => {
              dispatch(failure(error ? error.toString() : 'error'));
            });
        }
      });
  };
}

const setCurrentQuestion = (currentQuestion) => {
  localStorage.setItem('currentQuestion', JSON.stringify(currentQuestion));
  return ({
    type: examType6Constants.SET_CURRENT_QUESTION,
    currentQuestion,
  });
};

export const checkExamBeginTime = (additionalTime, duration, examId) => {
  const time = new Date();
  const savedDate = localStorage.getItem(`examBeginTime_${examId}`);
  const oldDate = new Date();
  oldDate.setFullYear(oldDate.getFullYear() - 1);
  let examBeginTime = new Date(JSON.parse(savedDate));
  if (examBeginTime.getTime() < oldDate.getTime()) {
    examBeginTime = new Date();
    examBeginTime.setTime(examBeginTime.getTime());
  }
  examBeginTime.setTime(examBeginTime.getTime() + (additionalTime ? additionalTime * 60 * 1000 : 0));
  examBeginTime.setTime(examBeginTime.getTime() + (60 * 1000 * duration));
  if (examBeginTime < time) {
    return false;
  }
  return (examBeginTime.getTime() - time.getTime());
};

const setExamBeginTime = (examId) => {
  const time = new Date();
  localStorage.setItem(`examBeginTime_${examId}`, JSON.stringify(time));
  return ({
    type: examType6Constants.SET_EXAM_BEGIN_TIME,
    time,
  });
};

const setCurrentAnswer = (currentAnswer) => ({
  type: examType6Constants.SET_CURRENT_ANSWER,
  currentAnswer,
  created_at: new Date(),
});

const setMultiQuestionId = (id) => ({
  type: examType6Constants.SET_MULTI_QUESTION_ID,
  id,
});

const pushAnswer = () => async (dispatch, getState) => {
  const state = getState();
  const { currentAnswer } = state.exam;
  let tmpanswers = localStorage.getItem('answers') !== null ? JSON.parse(localStorage.getItem('answers')) : [];

  // Si le localStorage est vide alors que Redux a des réponses, on utilise Redux comme source de vérité
  if (tmpanswers.length === 0 && state.exam.answers && state.exam.answers.length > 0) {
    tmpanswers = [...state.exam.answers];
  }

  // Si toujours vide, fallback sur le serveur pour récupérer les réponses déjà enregistrées
  if (tmpanswers.length === 0) {
    try {
      const exam = await examType6Services.getTestById(state.exam.exam.testId);
      const userExam = await examType6Services.getTest(state.user.userData._id, exam.pool);
      if (userExam && userExam.answers && userExam.pool === exam.pool) {
        userExam.answers.forEach((answer) => {
          tmpanswers.push({
            answerIndex: answer.answerIndex,
            question: answer.question._id,
            created_at: new Date(answer.created_at),
          });
        });
      }
    } catch (e) {
      // fallback silencieux : on continue avec tmpanswers vide
    }
  }

  const answers = [...tmpanswers, ...currentAnswer];
  localStorage.setItem('answers', JSON.stringify(answers));
  dispatch({
    type: examType6Constants.PUSH_ANSWER,
    answers,
  });
};

const clearTest = (testId) => {
  localStorage.removeItem('exam');
  localStorage.removeItem('currentQuestion');
  localStorage.removeItem('answers');
  localStorage.removeItem(`examBeginTime_${testId}`);
  return (dispatch) => {
    dispatch({ type: examType6Constants.CLEAR_EXAM });
  };
};

const clearAnswers = () => {
  localStorage.removeItem('currentQuestion');
  localStorage.removeItem('answers');
  return (dispatch) => {
    dispatch({ type: examType6Constants.CLEAR_EXAM_ANSWERS });
  };
};

const setSaveStatus = (status) => ({
  type: examType6Constants.SET_SAVE_STATUS,
  status, // 'pending' | 'saved' | 'error'
});

const examType6Actions = {
  initTest,
  setMultiQuestionId,
  setCurrentQuestion,
  setCurrentAnswer,
  pushAnswer,
  clearTest,
  clearAnswers,
  setExamBeginTime,
  setSaveStatus,
};

export default examType6Actions;
